import { applyMiddleware, createStore, compose } from 'redux'

import createSagaMiddleware from 'redux-saga'
import { routerMiddleware } from 'connected-react-router'
import thunkMiddleware from 'redux-thunk'

import { createRootReducer } from './root-reducer'
import { rootSaga } from './root-saga'

const composeEnhancers = (
  window && window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__
) || compose

export const configureStore = (initialState = {}, history) => {
  const sagaMiddleware = createSagaMiddleware()

  const middlewares = [routerMiddleware(history), thunkMiddleware, sagaMiddleware]
  const enhancer = composeEnhancers(applyMiddleware(...middlewares))
  const reducers = createRootReducer(history)

  const store = createStore(reducers, initialState, enhancer)

  sagaMiddleware.run(rootSaga, initialState)

  return store
}
